import {useState,useEffect} from "react";
import axios from "axios";
import realtimeDB from "../Utils/api";

const useCategorias = () =>
{
    const [Categorias, setCategorias] = useState([]);
    useEffect(() => 
    {
        realtimeDB.ref("/Menu").child("/CategoriasDOS").on("value",snapshot =>
        {
            let categorias =[];
            snapshot.forEach(categoria =>
            {
                let items=[]
                const {Items}=categoria.val();
                if(Items!==undefined)
                {
                   Object.values(Items).map(item =>
                    {
                        items.push(item);
                    })
                }
                let data=categoria.val();
                items=items.sort((a,b) => (Number(a.Indice) > Number(b.Indice)) ? 1 : ((b.Indice > Number(a.Indice)) ? -1 : 0));
                data.Items=items;
                if(categoria!==undefined)
                {
                    categorias.push({id:categoria.key,data:data})
                }
            })
            categorias= categorias.sort((a,b) => (Number(a.data.Indice) > Number(b.data.Indice)) ? 1 : ((b.data.Indice > Number(a.data.Indice)) ? -1 : 0));
            setCategorias(categorias);
        })
    }, []);
    return Categorias;
}

export default useCategorias;